<template>
    <div>
        <div id="slowPop" :class="slows?'animate':''" @touchmove.prevent v-if="slows">
            <div class="box">
                <img :src="icons" alt="" class="icons">
                <div>审核已提交</div>
                <img src="../assets/images/copy.png" alt="" class="right">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{

        },
        props:["slows","icons"],
        data() {
            return {
                
            }
        },
        created() {
            // console.log(this.slows);
        },
        methods: {

        },
    }
</script>

<style lang="less" scoped>
    #slowPop{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:10;
        background:rgba(127,127,127,.5);
        opacity: 0;
        .box{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            background: #FFFFFF;
            border-radius: 10px;
            width: 220px;
            padding: 15px 0 10px;
            // height: 120px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            div{
                font-size: 16px;
                font-weight: lighter;
                margin: 10px 0 0px;
            }
            .icons{
                width: 50px;
                height: 50px;
            }
            .right{
                width: 30px;
                height: 30px;
            }
        }

        
    }

    .animate{
        animation: opacity-1 2.5s linear;
        -webkit-animation: opacity-1 2.5s linear;
    }
    @keyframes opacity-1{
        0% {
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        70% {
            opacity: 1;
        }
        85% {
            opacity: 0.5;
        }
        100% {
            opacity: 0;
        }
    }
    @-webkit-keyframes opacity-1{
        0% {
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        70% {
            opacity: 1;
        }
        85% {
            opacity: 0.5;
        }
        100% {
            opacity: 0;
        }
    }

    

    .showBox{
        width: 120px;
        height: 50px;
        background: skyblue;
        color: #FFFFFF;
        text-align: center;
        line-height: 50px;
    }
</style>